export const regexp = {
  uppercase: /[A-Z]+/g,
  lowercase: /[a-z]+/g,
  number: /\d+/g,
  minCharacters: /\S{8,}/g,
  spaceStart: /^[\S]+/g,
  spaceEnd: /.*[\S]+$/g
}

export const passValidation = (reg, value) => value.match(reg)
